import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdminRoutingModule } from './admin-routing.module';
import { UserManagementComponent } from '../user-management/user-management.component';
import { AdminComponent } from './admin.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { DataTablesModule } from 'angular-datatables';
import { AngularMyDatePickerModule } from 'angular-mydatepicker';
import { ModalComponent } from '../modal/modal.component';
import { HomeModule } from '../home/home.module';
import { ShipmentComponent } from '../shipment/shipment.component';
import { GuaranteComponent } from '../guarante/guarante.component';


@NgModule({
  declarations: [UserManagementComponent, AdminComponent ],
  imports: [
    CommonModule,
    AdminRoutingModule,
    TranslateModule,
    DataTablesModule,
    NgbModalModule,
    FormsModule,
    ReactiveFormsModule,
    AngularMyDatePickerModule,
    HomeModule
  ],
  entryComponents: [
    ModalComponent, ShipmentComponent, GuaranteComponent
  ]
})
export class AdminModule { }
